module.exports = __webpack_public_path__ + "static/media/values.545a7416.png";